"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImageBackground = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledImageBackground = styled_components_1.default.div `
  align-items: center;
  background-image: url(${(props) => props.url});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-height: ${(props) => (props.hero ? '0' : '850px')};

  @media ${config_1.device.laptop} {
    background: ${(props) => (props.hero ? 'not set' : 'none')};
    display: flex;
    flex-direction: row;
    min-height: ${(props) => (props.hero ? '0' : '700px')};
  }
`;
